import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import type { CreateClienteIntermedioWithUserInput } from "@/lib/validaciones/createClienteIntermedioWithUsuario.validacion";
import { createClienteIntermedioWithUserSchema } from "@/lib/validaciones/createClienteIntermedioWithUsuario.validacion";
import { useRegisterClienteIntermedioWithUsuario } from "@/hooks/clientes-intermedios/useRegisterClienteIntermedioWithUsuarioForm";
import { Input } from "@/components/ui/input";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../ui/form";
import { BusyButton } from "@/components/ui/BusyButton";

export function RegisterClienteIntermedioWithUsuarioForm(
  { setOpen }: { setOpen: (open: boolean) => void } = { setOpen: () => {} },
) {
  const form = useForm<CreateClienteIntermedioWithUserInput>({
    resolver: zodResolver(createClienteIntermedioWithUserSchema),
    defaultValues: {
      usuario: {
        nombreUsuario: "",
        correo: "",
        contrasena: "",
        nombre: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        idRol: 2,
      },
      cliente: {
        nombreEmpresa: "",
      },
    },
  });

  const { mutate, isPending } = useRegisterClienteIntermedioWithUsuario();

  const onSubmit = (data: CreateClienteIntermedioWithUserInput) => {
    mutate(data, {
      onSuccess: () => {
        form.reset();
        setOpen(false);
      },
    });
  };

  return (
    <div className="flex justify-center items-center px-2 sm:px-4">
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="space-y-4 sm:space-y-6 w-full"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
            <FormField
              control={form.control}
              name="usuario.nombreUsuario"
              render={({ field }) => (
                <FormItem>
                  <FormLabel required>Nombre de usuario</FormLabel>
                  <FormControl>
                    <Input placeholder="Nombre de usuario" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="usuario.nombre"
              render={({ field }) => (
                <FormItem>
                  <FormLabel required>Nombre</FormLabel>
                  <FormControl>
                    <Input placeholder="Nombre" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="usuario.apellidoPaterno"
              render={({ field }) => (
                <FormItem>
                  <FormLabel required>Apellido paterno</FormLabel>
                  <FormControl>
                    <Input placeholder="Apellido" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="usuario.apellidoMaterno"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Apellido materno</FormLabel>
                  <FormControl>
                    <Input placeholder="Apellido materno" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="usuario.correo"
              render={({ field }) => (
                <FormItem>
                  <FormLabel required>Correo</FormLabel>
                  <FormControl>
                    <Input placeholder="correo@ejemplo.com" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="usuario.contrasena"
              render={({ field }) => (
                <FormItem>
                  <FormLabel required>Contraseña</FormLabel>
                  <FormControl>
                    <Input type="text" placeholder="*******" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="cliente.nombreEmpresa"
              render={({ field }) => (
                <FormItem className="md:col-span-2">
                  <FormLabel required>Nombre de la empresa</FormLabel>
                  <FormControl>
                    <Input placeholder="Nombre de la empresa" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <BusyButton
            busy={isPending}
            type="submit"
            variant="primary"
            className="w-full h-10 sm:h-11 text-sm sm:text-base"
          >
            Registrar
          </BusyButton>
        </form>
      </Form>
    </div>
  );
}
